import routes from '@/Router/routes.constants'

export const getVariantBasePath = ({
  categoryId,
  categoryPosition,
  collectionId,
  collectionPosition,
  typeId,
  typePosition,
  isUnifiedDashboard,
}) => {
  if (categoryId) {
    const pathName = isUnifiedDashboard
      ? routes.merchantDashboardVariantByCategoryMetricsDetailPage
      : routes.variantByCategoryMetricsDetailPage

    return pathName.replace(':categoryPosition', categoryPosition)
  }

  if (collectionId) {
    const pathName = isUnifiedDashboard
      ? routes.merchantDashboardVariantByCollectionMetricsDetailPage
      : routes.variantByCollectionMetricsDetailPage

    return pathName.replace(':collectionPosition', collectionPosition)
  }

  if (typeId) {
    const pathName = isUnifiedDashboard
      ? routes.merchantDashboardVariantByTypeMetricsDetailPage
      : routes.variantByTypeMetricsDetailPage

    return pathName.replace(':typePosition', typePosition)
  }

  return isUnifiedDashboard
    ? routes.merchantDashboardProductVariantMetricsDetailPage
    : routes.productVariantMetricsDetailPage
}
